// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { TECMessagesModel } from "@insite/client-framework/Types/ApiModels";
import { GetTECMessagesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import { TECMessagesState } from "@store/Framework/Store/Greif/Data/TECMessages/TECMessagesState";
import { Draft } from "immer";

const initialState: TECMessagesState = {
    isLoading: {},
    byId: {},
    dataViews: {},
};

const actions = {
    "Data/TECMessages/BeginLoadTECMessages": (
        draft: Draft<TECMessagesState>,
        action: { parameter: GetTECMessagesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/TECMessages/CompleteLoadTECMessages": (
        draft: Draft<TECMessagesState>,
        action: {
            parameter: GetTECMessagesApiParameter;
            collection: TECMessagesModel;
        },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => Object(collection)!);

        if (draft.failedToLoadTECMessages) {
            draft.failedToLoadTECMessages = false;
        }
    },

    "Data/TECMessages/FailedToLoadTECMessages": (draft: Draft<TECMessagesState>) => {
        draft.failedToLoadTECMessages = true;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataTECMessagesActions = Parameters<typeof reducer>[1];
export default reducer;
